"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.AccordionVariantBody = exports.AccordionVariantCollapse = exports.AccordionVariantToggle = exports.AccordionVariantIcon = exports.AccordionVariantTitle = exports.AccordionVariantHeader = exports.AccordionVariantCard = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Icon = _interopRequireDefault(require("../Icon"));

var AccordionVariantCard = (0, _styled.default)('div')(function () {
  return function (_ref) {
    var _ref$theme = _ref.theme,
        accordionVariant = _ref$theme.accordionVariant,
        space = _ref$theme.space;

    var _accordionVariant$car, _accordionVariant$car2;

    return {
      padding: "".concat(space.small, " 0"),
      backgroundColor: accordionVariant.card.bgColor,
      borderTop: (_accordionVariant$car = accordionVariant.card) === null || _accordionVariant$car === void 0 ? void 0 : _accordionVariant$car.border,
      overflow: 'hidden',
      cursor: 'pointer',
      '&:last-child': {
        marginBottom: 0,
        borderBottom: (_accordionVariant$car2 = accordionVariant.card) === null || _accordionVariant$car2 === void 0 ? void 0 : _accordionVariant$car2.border
      }
    };
  };
});
exports.AccordionVariantCard = AccordionVariantCard;
var AccordionVariantHeader = (0, _styled.default)('div')(function () {
  return function (_ref2) {
    var space = _ref2.theme.space;
    return {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: "".concat(space.small, " ").concat(space.medium),
      transition: 'all 0.4s ease-in-out'
    };
  };
});
exports.AccordionVariantHeader = AccordionVariantHeader;
var AccordionVariantTitle = (0, _styled.default)('div')(function () {
  return {
    transition: '0.3s'
  };
});
exports.AccordionVariantTitle = AccordionVariantTitle;
var AccordionVariantIcon = (0, _styled.default)(_Icon.default)(function () {
  return function () {
    return {
      position: 'relative',
      transition: '0.35s'
    };
  };
});
exports.AccordionVariantIcon = AccordionVariantIcon;
var AccordionVariantToggle = (0, _styled.default)('div')(function () {
  return {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    cursor: 'pointer',
    transition: '0.3s'
  };
});
exports.AccordionVariantToggle = AccordionVariantToggle;
var AccordionVariantCollapse = (0, _styled.default)('div')(function () {
  return function (_ref3) {
    var isActive = _ref3.isActive,
        scrollHeight = _ref3.scrollHeight;
    return {
      height: isActive ? scrollHeight : 0,
      overflow: 'hidden',
      transition: 'height 0.35s ease'
    };
  };
});
exports.AccordionVariantCollapse = AccordionVariantCollapse;
var AccordionVariantBody = (0, _styled.default)('div')(function () {
  return function (_ref4) {
    var space = _ref4.theme.space;
    return {
      flex: '1 1 auto',
      padding: "".concat(space.small, " ").concat(space.medium)
    };
  };
});
exports.AccordionVariantBody = AccordionVariantBody;